export const buildVersion = 'HEAD';
